import { BaseAdapter } from './base.adapter';
import type { PulseCategory, SOPGenerateJob } from '@/types';
import type { PulseSubcategoryCountsResponseDto, SOPJobStatusResponseDto } from '@/types';

export class PulseAdapter extends BaseAdapter {
  static fromSubcategoryCountsApi(dto: PulseSubcategoryCountsResponseDto): PulseCategory[] {
    return (dto.data ?? []).map((cat) => ({
      category: cat.category,
      subcategories: cat.subcategories.map((sub) => ({
        name: sub.name,
        count: sub.count,
        sopCatId: sub.sopCatId,
        sopStatus: sub.sopStatus,
        sopCount: sub.sopCount
      }))
    }));
  }

  static fromJobStatusApi(dto: SOPJobStatusResponseDto): SOPGenerateJob {
    return {
      jobId: dto.data.jobId,
      jobType: dto.data.jobType ?? 'sop_generation',
      status: dto.data.status,
      statusMessage: dto.data.statusMessage ?? null,
      queuedAt: dto.data.queuedAt ?? null,
      startedAt: dto.data.startedAt ?? null,
      completedAt: dto.data.completedAt ?? null,
      durationMs: dto.data.durationMs ?? null,
      suggestedPollIntervalMs: dto.data.suggestedPollIntervalMs ?? 10000,
      result: dto.data.result,
      error: dto.data.error
    };
  }
}
